import { redirect } from '@tanstack/react-router';

function nonEmpty(value: string | null): string | undefined {
  return value == null || value === '' ? undefined : value;
}

/**
 * The legacy Unity password links under `/users/`, forwarded to the Hydra password pages. `splat` is
 * the path after `/users/`, and `query` the browser's query string: the router's copy of a token
 * that reads as a number is already changed. Returns `null` for any other path.
 */
export function legacyPasswordRedirect(splat: string, query: string) {
  const path = splat.replace(/\/+$/, '');
  if (path === 'password/new') {
    return redirect({ to: '/reset_password', replace: true });
  }
  if (path === 'password/edit') {
    // Older reset and invite emails carry snake_case params.
    const params = new URLSearchParams(query);
    return redirect({
      to: '/reset_password/new_password',
      search: {
        resetPasswordToken: nonEmpty(params.get('reset_password_token')),
        source: nonEmpty(params.get('source')),
        inviteType: nonEmpty(params.get('invite_type')),
        origin: nonEmpty(params.get('origin')),
      },
      replace: true,
    });
  }
  return null;
}
